import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Fragment } from "react";
import { MyHead } from "../../components/pages/MyHead";
import { Grid } from "@mantine/core";
import { useTranslation } from "next-i18next";
import { PageHeader } from "../../components/pages/page-header/PageHeader";
import { MyH1 } from "../../components/UI/my-h1/MyH1";
import { isPhone } from "../../constants/env";
import { useColors } from "../../hooks/colors/useColors";
import { Container } from "../../components/UI/container/Container";
import { SpecialtyCard } from "../../components/pages/specialty/SpecialtyCard";
import { useLinks } from "../../components/pages/navbar/popover-link/useLinks";
import { isMobile } from "react-device-detect";
import { Footer } from "../../components/pages/homepage/footer/Footer";

export async function getStaticProps(context: any) {
  return {
    props: {
      ...(await serverSideTranslations(context.locale, ["common"])),
    },
  };
}

function SpecialtyListPage() {
  const { specialtyCards } = useLinks();
  const { t } = useTranslation("common");
  const { colors } = useColors();
  return (
    <Fragment>
      <MyHead
        title={t("specialties-title")}
        description={t("team.doctors-h1-1")}
      />
      <PageHeader>
        <MyH1
          size={isPhone ? "2.5rem" : "3rem"}
          color="white"
          className="text-center"
        >
          {t("specialties-title")}
        </MyH1>
      </PageHeader>
      <Container noHeight>
        <Fragment>
          {specialtyCards() && (
            <Fragment>
              {specialtyCards().map((category) => {
                return (
                  <Grid key={category.title}>
                    <Grid.Col span={12}>
                      <h1
                        style={{ color: colors.primary }}
                        className={
                          isMobile
                            ? "text-center text-4xl"
                            : "text-center text-5xl"
                        }
                      >
                        {category.title}
                      </h1>
                    </Grid.Col>
                    {category.specialties.map((specialty, index) => {
                      return (
                        <Grid.Col
                          key={specialty.name}
                          span={{ base: 12, md: 6, lg: 4 }}
                          className="flex justify-center"
                        >
                          <SpecialtyCard
                            description={specialty.description}
                            href={`/especialidades/${specialty.urlSlug}`}
                            image={specialty.image}
                            title={specialty.name}
                          />
                        </Grid.Col>
                      );
                    })}
                  </Grid>
                );
              })}
            </Fragment>
          )}
        </Fragment>
      </Container>
      <Footer
        isVisible={
          typeof specialtyCards() !== "undefined" && specialtyCards().length > 3
        }
        delay
      />
    </Fragment>
  );
}

export default SpecialtyListPage;
